import React from 'react';
import { Modal, ModalBody, ModalContent } from '@chakra-ui/react';
import { Page } from './Page';

interface ModalProps {
  isOpen: boolean;
  title: string;
  onClose: () => void;
}

export const ModalPage: React.FC<ModalProps> = ({
  isOpen,
  title,
  children,
  onClose,
}) => (
  <Modal isOpen={isOpen} onClose={onClose} size="full">
    <ModalContent m={0}>
      <ModalBody p={0}>
        <Page title={title} onBackClick={onClose}>
          {children}
        </Page>
      </ModalBody>
    </ModalContent>
  </Modal>
);
